/* Sleeplo — Carousel Web Component */
class SleepLoCarousel extends HTMLElement {
  connectedCallback() {
    this.track   = this.querySelector('[data-sl-track]');
    this.prevBtn = this.querySelector('[data-sl-prev]');
    this.nextBtn = this.querySelector('[data-sl-next]');
    if (!this.track) return;

    this.prevBtn?.addEventListener('click', () => this.slide(-1));
    this.nextBtn?.addEventListener('click', () => this.slide(1));
    this.track.addEventListener('scroll', () => this.sync(), { passive: true });

    this.ro = new ResizeObserver(() => this.sync());
    this.ro.observe(this.track);
    this.sync();
  }

  disconnectedCallback() { this.ro?.disconnect(); }

  slide(dir) {
    const card = this.track.querySelector('[data-sl-card]');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
  }

  sync() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    this.prevBtn?.toggleAttribute('disabled', scrollLeft <= 2);
    this.nextBtn?.toggleAttribute('disabled', scrollLeft >= scrollWidth - clientWidth - 2);
  }
}

customElements.define('sleeplo-carousel', SleepLoCarousel);
